<div class="flight_skeleton" *ngIf="cardCount">
    <div *ngFor="let a of counter(cardCount); let index = index" class="flight_card_skeleton seatcard">
        <span class="pointer top-label"><span></span></span>
        <div *ngFor="let a of counter(2); let index = index" class="skeleton_row">
            <div class="seat-accrd-header skeleton_row_1">
                <div class="circle"></div>
                <div class="title-line"></div>
                <div class="description-line"></div>
                <div class="arrow-box"></div>
            </div>
            <div class="seat-accrd-body skeleton_row_2">
                <div class="timings date_skeleton">
                    <div class="date-line"></div>
                    <div class="stop-box"></div>
                    <div class="date-line"></div>
                </div>
                <div class="total_time"></div>
                <!-- <div class="flight-data">
                    <div class="flight-data-head">
                        <div class="circle"></div>
                        <div class="title_line"></div>
                    </div>
                    <div class="departure-arrival-desktop">
                        <div class="departure-arrival">
                            <div class="departure-line"></div>
                            <div class="stop-box"></div>
                            <div class="arrival-line"></div>
                        </div>
                    </div>
                    <div class="departure-arrival-timing">
                        <div class="time_line"></div>
                        <div class="time_line"></div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>